import type { PageProps } from '@/types'
import { router } from '@inertiajs/vue3'
import * as Sentry from '@sentry/vue'

const syncSentryUser = (pageProps?: Partial<PageProps>) => {
  const user = pageProps?.auth?.user

  if (!user) {
    Sentry.setUser(null)
    return
  }

  Sentry.setUser({
    email: user.email,
    username: `${user.first_name} ${user.last_name}`,
  })
}

export function useSentryUserSync(initialPageProps?: Partial<PageProps>) {
  syncSentryUser(initialPageProps)

  router.on('success', (event) => {
    syncSentryUser(event.detail.page.props as Partial<PageProps>)
  })
}
